<template>
	<div class="indexAll">
		<back-to></back-to>
		<section class="indexAll-cont">
			<div class="indexAll-cont_title">
				<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/indexAll_01.png" alt="">
				<p>国内旅游</p>
			</div>
			<div class="indexAll-cont_item">
				<p v-for="(item,index) in freedom" :key="index"
					@click="item.url!=''?$router.push({ path: item.url}):toast()">{{item.name}}
				</p>
			</div>
		</section>
		<section class="indexAll-cont">
			<div class="indexAll-cont_title">
				<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/indexAll_02.png" alt="">
				<p>出境旅游</p>
			</div>
			<div class="indexAll-cont_item">
				<p v-for="(item,index) in leave" :key="index"
					@click="item.url!=''?$router.push({ path: item.url}):toast()">{{item.name}}</p>
			</div>
		</section>
		<section class="indexAll-cont">
			<div class="indexAll-cont_title">
				<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/indexAll_03.png" alt="">
				<p>交通旅行</p>
			</div>
			<div class="indexAll-cont_item">
				<p v-for="(item,index) in traffic" :key="index"
					@click="item.url!=''?$router.push({ path: item.url}):toast()">{{item.name}}
				</p>
			</div>
		</section>
		<section class="indexAll-cont">
			<div class="indexAll-cont_title">
				<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/indexAll_04.png" alt="">
				<p>周边玩乐</p>
			</div>
			<div class="indexAll-cont_item">
				<p v-for="(item,index) in ambitus" :key="index"
					@click="item.url!=''?$router.push({ path: item.url}):toast()">{{item.name}}
				</p>
			</div>
		</section>
		<section class="indexAll-cont">
			<div class="indexAll-cont_title">
				<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/indexAll_05.png" alt="">
				<p>会员中心</p>
			</div>
			<div class="indexAll-cont_item">
				<p v-for="(item,index) in feature" :key="index"
					@click="item.url!=''?$router.push({ path: item.url}):toast()">{{item.name}}
				</p>
			</div>
		</section>
		<section class="indexAll-cont">
			<div class="indexAll-cont_title">
				<img src="https://sweetour-pic.obs.myhwclouds.com/sweetmini/indexAll_06.png" alt="">
				<p>目的地</p>
			</div>
			<div class="indexAll-cont_items">
				<p v-for="(item,index) in destination" :key="index"
					@click="$router.push({path: '/packageSearch',query:{disArr:item,type:1}})">{{item.Name}}</p>
				<p @click="$router.push({ path: '/more?type=1'})">更多</p>
			</div>
		</section>
	</div>
</template>

<script>
	import {
		Toast
	} from 'vant'
	import BackTo from "@/components/BackTo";
	export default {
		name: 'indexAll',
		components: {
			BackTo
		},
		data() {
			return {
				destination: [],
				//  国内旅游
				freedom: [
					// {
					// 	name: '自由行',
					// 	url: '../freedom/freedom'
					// },
					{
						name: '跟团游',
						url: '/packageTour?title=国内跟团游&type=1'
					},
					{
						name: '邮轮游',
						url: '/cruise'
					},
					{
						name: '景点门票',
						url: '/touristIndex'
					},
					{
						name: '定制游',
						url: '/customSwim'
					},
					{
						name: '旅游门票',
						url: ''
					},
				],
				//出境旅游
				leave: [{
						name: '签证',
						url: ''
					},
					{
						name: 'Wifi电话卡',
						url: ''
					},
					// {
					//   name:'国际用车',
					//   url:''
					// },
					{
						name: '旅行购',
						url: ''
					},
					{
						name: '国际门票',
						url: ''
					},
					{
						name: '当地玩乐',
						url: ''
					},
					// {
					//   name:'翻译助手',
					//   url:''
					// },
					{
						name: '国际酒店',
						url: ''
					},
				],
				//交通旅行
				traffic: [{
						name: '机票',
						url: ''
					},
					{
						name: '特价机票',
						url: ''
					},
					{
						name: '接送机',
						url: ''
					},
					{
						name: '汽车票',
						url: ''
					},
					{
						name: '火车票',
						url: ''
					},
				],
				//周边玩乐
				ambitus: [{
						name: '景点门票',
						url: '/touristIndex'
					},
					{
						name: '亲子游',
						url: '/classList?id=4'
					}
				],
				//特色权益
				feature: [{
						name: '积分商城',
						url: ''
					},
					{
						name: '会员日',
						url: ''
					}
				],
			}
		},
		computed: {

		},
		mounted() {
			this.connect_HotImageAd()
		},
		methods: {
			toast() {
				Toast("敬请期待")
			},
			connect_HotImageAd() {
				this.$post(
					this.$apiWebsiteSweet + '/api/GetGTLine', {
						State: 0, // 0国内 1国外
						Count: 20 // 多少条
					}
				).then(res => {
					let len = res.GN.length - 1
					this.destination = res.GN.splice(1, len)
				})
			},
		},
		beforeCreate() {
			document.querySelector('body').setAttribute('style', 'background-color:#f2f2f2')
		}
	}
</script>

<style scoped>
	.indexAll-cont {
		width: 100%;
		padding: 20px;
		box-sizing: border-box;
	}

	.indexAll-cont_title {
		display: flex;
		align-items: center;
	}

	.indexAll-cont_title img {
		width: 41px;
		height: 41px;
		margin-right: 20px;
	}

	.indexAll-cont_title p {
		font-size: 32px;
		color: #333;
	}

	.indexAll-cont_item {
		width: 100%;
		padding: 30px 0 20px 0;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;
	}

	.indexAll-cont_item p {
		box-sizing: border-box;
		width: 25%;
		height: 71px;
		background: #fff;
		color: #333;
		font-size: 28px;
		line-height: 71px;
		text-align: center;
		border: 1px solid #eaeaea;
		border-left: none;
	}

	.indexAll-cont_items {
		width: 100%;
		padding: 30px 0 20px 0;
		box-sizing: border-box;
		display: flex;
		flex-wrap: wrap;
	}

	.indexAll-cont_items p {
		text-align: center;
		height: 70px;
		width: 152px;
		border-radius: 35px;
		border: 1px solid #eaeaea;
		background: #fff;
		color: #333;
		font-size: 28px;
		margin-bottom: 30px;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		box-sizing: border-box;
		margin-left: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.indexAll-cont_items p:nth-of-type(4n-3) {
		margin-left: 0;
	}
</style>
